/**
 * A set of options we provide to our core Table component for how it should behave
 */
export class TableOptions {
  /**
   * This flag requires that an expandedColumn is provided to the table to have any effect.
   * It will make that template always show, rather than being hidden and need to be clicked
   * on before it shows.
   * @defaultValue false
   * @type {boolean}
   */
  public alwaysExpanded: boolean;

  /**
   * Configuration flag for determining if the table should include pagination features
   * @defaultValue true
   * @type {boolean}
   */
  public usePagination: boolean;

  /**
   * Configuration for Pagination, will not have any effect if no usePagination is not true.
   * Provides an array of numbers to be used as options for page size.
   * @defaultValue [10, 25, 50]
   * @type {number[]}
   */
  public pageSizeOptions: number[];

  /**
   * Configuration for sortable headers. Setting this to true will enable headers to be
   * sortable.  To make use of this, TableColumns given to the table must set sortable
   * to true to be sortable.  Otherwise, if all columns are sortable: false then this
   * will have no effect.
   * @defaultValue true
   * @type {boolean}
   */
  public sortable: boolean;

  /**
   * Configuration to show the table header. Setting this to false will hide headers.
   * @defaultValue true
   * @type {boolean}
   */
  public showHeader: boolean;

  /**
   * Configuration to use mat-elevation-z class. Setting this to false will remove z elevations from the table.
   * @defaultValue true
   * @type {boolean}
   */
  public useElevation: boolean;

  /**
   * Configuration to show total footer row. Setting this to false will hide total footer row.
   * @defaultValue false
   * @type {boolean}
   */
  public showTotalsRow: boolean;

  /**
   * Configuration to show sticky header. Setting this to true to make sticky to container div.
   * @defaultValue false
   * @type {boolean}
   */
  public stickyHeader: boolean;

  /**
   * Table container classes.
   * @defaultValue false
   * @type {boolean}
   */
  public containerClass: string;

  constructor(
    alwaysExpanded?: boolean,
    sortable?: boolean,
    usePagination?: boolean,
    pageSizeOptions?: number[],
    showHeader?: boolean,
    useElevation?: boolean,
    showTotalsRow?: boolean,
    stickyHeader?: boolean,
    containerClass?: string,
  ) {
    this.alwaysExpanded = alwaysExpanded ?? false;
    this.sortable = sortable ?? true;
    this.usePagination = usePagination ?? true;
    this.pageSizeOptions = pageSizeOptions ?? [10, 25, 50];
    this.showHeader = showHeader ?? true;
    this.useElevation = useElevation ?? true;
    this.showTotalsRow = showTotalsRow ?? false;
    this.stickyHeader = stickyHeader ?? false;
    this.containerClass = containerClass ?? '';
  }
}
